import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { Modal } from '../__design-system/modal/modal';

interface AddonEditDisabledModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const AddonEditDisabledModal = ({ open, onOpenChange }: AddonEditDisabledModalProps) => {
	const { t } = useTranslation();

	return (
		<Modal open={open} onOpenChange={onOpenChange}>
			<Modal.Header closeModal={() => onOpenChange(false)}>
				{t('titles.addon_editing_disabled', { defaultValue: 'Add-on Editing Not Available' })}
			</Modal.Header>

			<Modal.Body>
				<p>
					{t('messages.addon_editing_disabled_explanation', {
						defaultValue: 'Add-on editing is not available for this reservation. To modify your add-ons, please contact us at'
					})}{' '}
					<a href={`mailto:${TDR.SUPPORT_EMAIL}`} className="text-blue-400 hover:text-blue-300 underline">
						{TDR.SUPPORT_EMAIL}
					</a>.
				</p>
			</Modal.Body>
		</Modal>
	);
};
